var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "rbvp-extra-options" },
    [
      _c(
        "VButton",
        {
          ref: "button",
          staticClass: "rbvp-settings-button",
          on: {
            mouseover: function ($event) {
              return _vm.loadSettings()
            },
            click: function ($event) {
              return _vm.toggle()
            },
          },
        },
        [
          _c("VIcon", { attrs: { icon: "mdi-tune", size: 18 } }),
          _vm._v("\n    RBVP 设置\n  "),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }